import React from "react";
import ImageOutlinedIcon from "@mui/icons-material/ImageOutlined";
import {useTranslation} from "react-i18next";
import type {PrintoutImageNodeAttrs} from "./printoutImageOptions";

const ImageView = ({attrs}: {attrs: Required<PrintoutImageNodeAttrs>}) => {
    const {t} = useTranslation();

    return (
        <div
            className="printout-image-block"
            data-printout-image-alignment={attrs.alignment}
        >
            <div
                className={attrs.src ? "printout-image-frame" : "printout-image-frame printout-image-frame-empty"}
                style={{
                    height: `${attrs.heightMm}mm`,
                    width: `${attrs.widthMm}mm`,
                }}
            >
                {attrs.src ? (
                    <img alt="" src={attrs.src} style={{objectFit: attrs.fit}}/>
                ) : (
                    <div className="printout-image-placeholder" contentEditable={false}>
                        <ImageOutlinedIcon fontSize="small"/>
                        <span className="printout-image-placeholder-size">
                            {attrs.widthMm} × {attrs.heightMm} mm
                        </span>
                        <span className="printout-image-placeholder-hint">
                            {t("Select the block to upload an image")}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ImageView;
